/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-06-18 01:07:06
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\login\locales\en-US.ts
 */
export default {
  'page.user.login.form-item-username': 'email/mobile number to login',
  'page.user.login.form-item-username.required': 'Please input your username',
  'page.user.login.form-item-password': 'password',
  'page.user.login.form-item-password.required': 'Please input your password',
  'page.user.login.form.title': 'Account Login',
  'page.user.login.form.btn-submit': 'Sign in',
  'page.user.login.form.btn-jump': 'or register now!',
  'page.user.login.form.login-error': 'Wrong username or password!',
  'page.user.login.form.login-success': 'Login successful!',
  'page.user.login.form.forgetmsg': 'Forget password',
  'page.user.login.form.verifica': 'Please enter the graphic code',
};
